// extracted by mini-css-extract-plugin
export default {"wrapper":"OVxuqjQ","outerWrapper":"KjCxFll","panel":"yfTcfdg","wrapper__open":"t7Pj9hR","wrapper__hidden":"Is_ZDWW","innerWrapper":"EGwAGf7"};